import { createFileRoute } from "@tanstack/react-router"
import { zodValidator } from "@tanstack/zod-adapter"

import { AdjustmentHistoryListPage } from "@/screens/Inventory/subfeatures/AdjustmentHistory/components/AdjustmentHistoryListPage"
import { adjustmentHistorySearchSchema } from "@/screens/Inventory/subfeatures/AdjustmentHistory/schemas"

export const Route = createFileRoute("/app/inventory/_layout/adjustment-history")({
  validateSearch: zodValidator(adjustmentHistorySearchSchema),
  component: () => <AdjustmentHistoryListPage />,
})
